import { AccordionSummary as NovaMuiAccordionSummary } from '@fme-nova/components'
import { AccordionSummaryProps, default as MuiAccordionSummary } from '@mui/material/AccordionSummary'

import { createComponentWrapperWithRef } from '../../theme'

export const AccordionSummary = createComponentWrapperWithRef<AccordionSummaryProps>(
  {
    mui: MuiAccordionSummary,
    nova: NovaMuiAccordionSummary,
  },
  'StyledToast',
)
